export const DEVICES = 'Devices'
export const NEED_HELP = 'Need Help'
export const DEVICES_LOCATIONS = 'Device Locations'
export const WHY = 'Why'
export const APPS = 'Apps'
